import React,{useEffect,useState} from "react";
import CustomHeading from '../../../constants/CustomHeading';
import CustomLabel from '../../../constants/CustomLabel';
import Faculty from "../../../assets/Faculty.svg";
import {  Formik, Form} from 'formik';
import * as Yup from 'yup';
import CustomInput from '../../../constants/CustomInput';
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomTextArea from '../../../constants/CustomTextArea';
import CustomButton from '../../../constants/CustomButton';
import {connect} from 'react-redux';
import {getProfileData} from '../../../redux/actions/dataAction';

const validationSchema = Yup.object().shape({
 
 
});
const FacultyProfile = (props) => {
  const [isLoading,setIsLoading]=useState(false);
  const [profile,setProfile]=useState()
  useEffect(()=>{
      props.getProfileData();
      
  },[isLoading])

  useEffect(()=>{
    setProfile(props?.profile?.data)
  },[props?.profile])
 
 console.log(profile)
  return (
   <div className="customContainer">
     <CustomHeading title="Faculty profile"/>
     <CustomLabel label={"Upload your profile Photo"}/>
     <Formik
         initialValues={{
               image:profile?.image || '',
               title:profile?.title || '',
               email:profile?.email || '',
               first_name:'',
               last_name:'',
               blood_group:'',
               phone_number:'',
               date_of_birth:'',
               aadhar_number:'',
               present_address:'',
               website:'',
               employee_no:'',
               facility_type:'',
               designation:'' ,
               professional_detail:[],
               qualification_detail:[],
               phd_detail:[],  
        }}
        validationSchema={validationSchema}
        onSubmit={values => {
         console.log(values)
         
       }}
     >
              {({ errors, touched,handleChange,handleSubmit,values }) => {
                console.log(values);
                return(
            <Form onSubmit={handleSubmit} style={{marginTop:0}}>
              <div className={'col-md-2'}>
                <label style={{width:'100%'}}>
              <input type="file" name="image" id="image" style={{display:'none'}} onChange={handleChange('image')}/>
              <img src={profile?.image || Faculty} style={{width:'100%',height:100}}/>
              </label>
              </div>
              <div className={'my-3'}>
              <CustomLabel label={"Employee Details"}/>
              </div>
              <div className="card  shadow p-3 mb-5 bg-white rounded">
              <CustomLabel label={"Personal Details"}/>
              <div className="row">
                    <div className="col-md-4">
                      <CustomDropdown 
                      label="Title : "
                      data={[{value:"Mr."},{value:"Mrs."},{value:"Ms."},{value:"Miss."},{value:"Prof."},{value:"Dr."}]}
                      onChange={handleChange('title')}
                      value={profile?.title}
                      errorText={
                          errors.title && touched.title ?errors.title :null
                      }
                      />
                    </div>
                    <div className="col-md-4">
                        <CustomInput
                        type={'text'}
                        label={'First Name :'}
                        onChange={handleChange('first_name')}
                        errorText={
                            errors.first_name && touched.first_name ?errors.first_name :null
                        }
                        value={profile?.first_name}
                    />
                    </div>
                    <div className="col-md-4">

                    <CustomInput
                      type={'text'}
                      label={'Last Name :'}
                      onChange={handleChange('last_name')}
                      errorText={
                          errors.last_name && touched.last_name ?errors.last_name :null
                      }
                      value={profile?.last_name}
                  />
                    </div>
                </div>



                <div className="row">
                    <div className="col-md-4">
                    <CustomInput
                        type={'email'}
                        label={'Email Id :'}
                        onChange={handleChange('email')}
                        errorText={
                            errors.email && touched.email ?errors.email :null
                        }
                        value={profile?.email}
                    />
                    </div>
                    <div className="col-md-4">
                        <CustomInput
                        type={'text'}
                        label={'Contact Number :'}
                        onChange={handleChange('phone_number')}
                        errorText={
                            errors.phone_number && touched.phone_number ?errors.phone_number :null
                        }
                        value={profile?.phone_number}
                    />
                    </div>
                    <div className="col-md-4">

                    <CustomInput
                      type={'text'}
                      label={'Aadhar Number :'}
                      onChange={handleChange('aadhar_number')}
                      errorText={
                          errors.aadhar_number && touched.aadhar_number ?errors.aadhar_number :null
                      }
                      value={profile?.aadhar_number}
                  />
                    </div>
                </div>



                <div className="row">
                    <div className="col-md-4">
                      <CustomDropdown 
                      label="Blood group : "
                      data={[{value:"A+"},{value:"A-"},{value:"B+"},{value:"B-"},{value:"O+"},{value:"O-"},{value:"AB+"},{value:"AB-"}]}
                      onChange={handleChange('blood_group')}
                      errorText={
                          errors.blood_group && touched.blood_group ?errors.blood_group :null
                      }
                      name={profile?.blood_group}
                      />
                    </div>
                    <div className="col-md-4">
                        <CustomInput
                        type={'date'}
                        label={'Date of Bairth :'}
                        onChange={handleChange('date_of_birth')}
                        errorText={
                            errors.date_of_birth && touched.date_of_birth ?errors.date_of_birth :null
                        }
                        value={profile?.date_of_birth}
                    />
                    </div>
                    <div className="col-md-4">

                    <CustomInput
                      type={'text'}
                      label={'Website :'}
                      onChange={handleChange('website')}
                      errorText={
                          errors.website && touched.website ?errors.website :null
                      }
                      value={profile?.website}
                  />
                    </div>
                </div>
                <CustomTextArea
                type={'text'}
                label={'Address'}
                onChange={handleChange('present_address')}
                errorText={
                    errors.present_address && touched.present_address ?errors.present_address :null
                }
                value={profile?.present_address}

            />
              </div>





              <div className="card  shadow p-3 mb-5 bg-white rounded">
              <CustomLabel label={"Professional Details"}/>
              <div className="row">
                    <div className="col-md-2">
                    <CustomInput
                      type={'text'}
                      label={'Employee No. :'}
                      onChange={handleChange('employee_no')}
                      errorText={
                          errors.employee_no && touched.employee_no ?errors.employee_no :null
                      }
                      value={profile?.employee_no}
                  />
                    </div>
                    <div className="col-md-4">
                    <CustomDropdown 
                      label="Faculty type : "
                      data={[{value:"Teaching"},{value:"Lab"},{value:"Administration"},{value:"Supporting"},{value:"Visiting"}]}
                      onChange={handleChange('facility_type')}
                      errorText={
                          errors.facility_type && touched.facility_type ?errors.facility_type :null
                      }
                      value={profile?.facility_type}
                      />
                    </div>
                    <div className="col-md-6">
                    <CustomDropdown 
                      label="Current Designation : "
                      data={[{value:"HOD"},{value:"Professor"},{value:"Assistant Professor"},{value:"Lecturer"},{value:"Principal"},{value:"Associate professor"}]}
                      onChange={handleChange('designation')}
                      errorText={
                          errors.designation && touched.designation ?errors.designation :null
                      }
                      value={profile?.designation[0]}
                      />

                    </div>
                </div>

              
                <div className="row">
                    <div className="col-md-4">
                    <CustomInput
                      type={'date'}
                      label={'Date of Joining :'}
                      onChange={handleChange('date_of_joining')}
                      errorText={
                          errors.date_of_joining && touched.date_of_joining ?errors.date_of_joining :null
                      }
                  />
                    </div>
                    <div className="col-md-4">
                    <CustomInput
                      type={'date'}
                      label={'Relieving Date :'}
                      onChange={handleChange('relieving_date')}
                      errorText={
                          errors.relieving_date && touched.relieving_date ?errors.relieving_date :null
                      }
                  />
                    </div>
                    <div className="col-md-4">
                    <CustomInput
                      type={'date'}
                      label={'Retirement Date :'}
                      onChange={handleChange('retirement_date')}
                      errorText={
                          errors.retirement_date && touched.retirement_date ?errors.retirement_date :null
                      }
                  />
                    </div>
                </div>
                  

                <div className="row">
                    <div className="col-md-4">
                    <CustomInput
                      type={'text'}
                      label={'Teaching Experience (in Years) :'}
                      onChange={handleChange('teaching_experience')}
                      errorText={
                          errors.teaching_experience && touched.teaching_experience ?errors.teaching_experience :null
                      }
                  />
                    </div>
                    <div className="col-md-4">
                    <CustomInput
                      type={'text'}
                      label={'Industrial Experience (in Years):'}
                      onChange={handleChange('industrial_experience')}
                      errorText={
                          errors.industrial_experience && touched.industrial_experience ?errors.industrial_experience :null
                      }
                  />
                    </div>
                    <div className="col-md-4">
                    <CustomInput
                      type={'text'}
                      label={'Total experience :'}
                      onChange={handleChange('total_experience')}
                      errorText={
                          errors.total_experience && touched.total_experience ?errors.total_experience :null
                      }
                  />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                    <CustomDropdown 
                      label="Faculty Serving : "
                      data={[{value:"Permanent"},{value:"Part time"},{value:"Contract Basis"}]}
                      onChange={handleChange('faculty_serving')}
                      errorText={
                          errors.faculty_serving && touched.faculty_serving ?errors.faculty_serving :null
                      }
                      />
                    </div>
                    <div className="col-md-4">
                    <CustomInput
                      type={'date'}
                      label={'Last promotion :'}
                      onChange={handleChange('last_promotion')}
                      errorText={
                          errors.last_promotion && touched.last_promotion ?errors.last_promotion :null
                      }
                  />
                    </div>
                    <div className="col-md-4">
                    <CustomInput
                      type={'text'}
                      label={'Salary Pay :'}
                      onChange={handleChange('salary_pay')}
                      errorText={
                          errors.salary_pay && touched.salary_pay ?errors.salary_pay :null
                      }
                  />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                    <CustomTextArea
                        type={'text'}
                        label={'Responsibilities'}
                        onChange={handleChange('responsibilties')}
                        errorText={
                            errors.responsibilties && touched.responsibilties ?errors.responsibilties :null
                        }

                    />
                    </div>
                    <div className="col-md-6">
                    <CustomTextArea
                      type={'text'}
                      label={'Remarks'}
                      onChange={handleChange('remarks')}
                      errorText={
                          errors.remarks && touched.remarks ?errors.remarks :null
                      }

                  />
                    </div>
                </div>
              </div>


              <div className="card  shadow p-3 mb-5 bg-white rounded">
              <CustomLabel label={"Qualification Details"}/>
              
              <CustomDropdown 
                label="Highest Qualification : "
                data={[{value:"BTech"},{value:"MTech"},{value:"Phd"}]}
                onChange={handleChange('highest_qualification')}
                errorText={
                    errors.highest_qualification && touched.highest_qualification ?errors.highest_qualification :null
                }
                />
                <div className="row">
                    <div className="col-md-4">
                    <CustomTextArea
                      type={'text'}
                      label={'Research Interest'}
                      onChange={handleChange('research_interest')}
                      errorText={
                          errors.research_interest && touched.research_interest ?errors.research_interest :null
                      }

                  />
                    </div>
                    <div className="col-md-4">
                    <CustomTextArea
                      type={'text'}
                      label={'Skills'}
                      onChange={handleChange('skills')}
                      errorText={
                          errors.skills && touched.skills ?errors.skills :null
                      }

                  />
                    </div>
                    <div className="col-md-4">
                    <CustomTextArea
                      type={'text'}
                      label={'Specialization'}
                      onChange={handleChange('specialization')}
                      errorText={
                          errors.specialization && touched.specialization ?errors.specialization :null
                      }

                  />
                    </div>
                </div>
                </div>
                <CustomButton type="submit" label="Update" isIcon/>
          </Form>);
}}
     </Formik>
   </div>
  );
};
const mapActionWithProps = {
  getProfileData,
}

const mapStateWithProps = (state)=>(
  {
    profile:state.data.profile
  }
)
export default connect(mapStateWithProps,mapActionWithProps)(FacultyProfile);
